import { canUseDOM as i } from "./DTR5TSDJ.js";
function r() {
  return i ? /mac|iphone|ipad|ipod/i.test(navigator.platform) : !1;
}
function e() {
  return i && r() && /apple/i.test(navigator.vendor);
}
function n() {
  return i && /firefox\//i.test(navigator.userAgent);
}
export {
  r as isApple,
  n as isFirefox,
  e as isSafari
};
//# sourceMappingURL=QAGXQEUG.js.map
